import ContactCenter from './../components/SucursalVirtual/Trabajador/ContactCenter/view';
export const checkAccess = (id, userFunctionalitiesIds) => {
  if (!id) return true;
  if (!Array.isArray(userFunctionalitiesIds)) return false;
  return userFunctionalitiesIds.indexOf(id) !== -1;
};

export const realCheckAccess = (id, userFunctionalitiesIds) => {
  if (!id) return true;
  // if (id) {
  //     return false;
  // } else {
  //     return false;
  // }
  if (!Array.isArray(userFunctionalitiesIds)) return false;

  return !!(userFunctionalitiesIds.indexOf(id) !== -1);
};

export const ids = {
  gestionarCapacitaciones: 'GES_CAPA_E_LEARNING',
  agendamientoExperto: 'AGENDA_EXPERTO_SMENU',
  autoevaluacion: 'AUTO_EMP_SMENU',
  trabajador: 'TRAB_MENU',
  siniestros: 'SIN_TRAB_SMENU',
  capacitaciones: 'CAP_TRAB_SMENU',
  prestaciones: 'PRES_TRAB_TAB',
  siniestro: 'SIN_TRAB_TAB',

  miEmpresa: 'EMP_MENU',
  resumenEmpresa: 'DATOS_EMP_SMENU',
  datosEmpresa: 'DATOS_EMP_TAB',
  gestionarUsuarios: 'GES_USER_EMP_SMENU',
  aprobarSolicitudes: 'SOL_EMP_TAB',
  asignarRoles: 'SET_ROLES_EMP_TAB',
  notificacionesE: 'SET_NOTIF_EMP_TAB',
  siniestrosEmpresa: 'SIN_EMP_SMENU',
  resumenSiniestro: 'RESUMEN_SIN_EMP_TAB',
  siniestroEmpresa: 'SIN_EMP_TAB',
  denunciasEmpresa: 'DEN_EMP_TAB',
  prestacionesEmpresa: 'PREST_EMP_TAB',
  cotizacionesEmpresa: 'COTIZACIONES_SMENU',
  declaracionCotizacion: 'FORM_DEC_TAB',

  miPerfil: 'MI_CUENTA_MENU',
  resumenMiCuenta: 'CUENTA_GEN_SMENU',
  miCuentaNotificaciones: 'CUENTA_NOTIF_SMENU',
  empresasAchs: 'EMP_ACHS_SMENU',
  contactCenter: 'CONTCNTER_ACHS_SMENU',
  empresasAutoasginadas: 'EMP_AUTOASI_TAB',
  notificacionesT: 'HIST_NOTIF_TRAB_TAB',
  misDatos: 'MIS_DATOS_TAB',
  mantenedorNotTrabajador: 'CONF_NOTIF_TRAB_TAB',
  usuario: 'USER_INFO_TAB',
  correoPassword: 'EMAIL_PASS_TAB',
  miCuentaSolicitudes: 'CUENTA_SOL_SMENU',
  solicitudesPendientes: 'SOL_TRAB_TAB',

  mantenedores: 'MANT_MENU',
  mantenedorGeneral: 'MANT_ROL_PERF_SMENU',
  roles: 'ROLES_TAB',
  perfiles: 'PERFILES_TAB',
  empresas: 'EMPRESAS_TAB',
  mantenedorNotificaciones: 'MANT_NOTIF_SMENU',
  mantenedorNotEmpresa: 'MANT_NOTIF_EMP_TAB',

  portalExterno: 'PORTAL_EXT_MENU',
  achsGestion: 'ACHS_GESTION_SMENU',
  portalEmpresa: 'PORTAL_EMP_SMENU',
  certificadosSEL: 'CERT_SEL_SMENU',
  lgf: 'LGF_SMENU',

  sel: 'SEL_MENU',
  callCenter: 'SOL_SEL_SMENU',
  agendaSel: 'AGENDA_SEL_SMENU',
  solicitudSel: 'SOL_SEL_TAB',
  crearSel: 'CREATE_SEL_TAB',
  seleccionarEmpresaSel: 'FUN_SELECCIONAR_EMPR',
  confirmacionSolicitudSel: 'CONF_SOL_SEL_TAB',

  movilidad: 'MOV_SMENU',
  adminMovilidad: 'ADM_MOV_TAB',
  gestorMovilidad: 'GES_MOV_TAB',

  examenes: 'EXAM_TRAB_SMENU',
  pagosPendientes: 'PPEND_TRAB_SMENU',
  estadoPension: 'PENS_IND_TRAB_SMENU',
  mundoAchs: 'MUNDO_ACHS_TRAB_SMEN',
  mundoAchsEmpresa: 'MUNDO_ACHS_EMPR_SMEN',
};

const listaFuncionalidades = [
  { Code: ids.trabajador, Description: 'Trabajador' },
  {
    Code: ids.siniestros,
    Description: 'Siniestros',
    parentCode: ids.trabajador,
  },
  {
    Code: ids.siniestro,
    Description: 'Siniestros trabajador',
    parentCode: ids.siniestros,
  },
  {
    Code: ids.prestaciones,
    Description: 'Prestaciones económicas',
    parentCode: ids.siniestros,
  },

  { Code: ids.miEmpresa, Description: 'Empresa' },
  {
    Code: ids.resumenEmpresa,
    Description: 'Datos empresa',
    parentCode: ids.miEmpresa,
  },
  {
    Code: ids.datosEmpresa,
    Description: 'Datos',
    parentCode: ids.resumenEmpresa,
  },

  {
    Code: ids.gestionarUsuarios,
    Description: 'Gestionar usuarios',
    parentCode: ids.miEmpresa,
  },
  {
    Code: ids.aprobarSolicitudes,
    Description: 'Aprobar solicitudes',
    parentCode: ids.gestionarUsuarios,
  },
  {
    Code: ids.asignarRoles,
    Description: 'Asignar roles',
    parentCode: ids.gestionarUsuarios,
  },
  {
    Code: ids.notificacionesE,
    Description: 'Notificaciones empresa',
    parentCode: ids.gestionarUsuarios,
  },

  {
    Code: ids.siniestrosEmpresa,
    Description: 'Siniestros empresa',
    parentCode: ids.miEmpresa,
  },
  {
    Code: ids.resumenSiniestro,
    Description: 'Resumen',
    parentCode: ids.siniestrosEmpresa,
  },
  {
    Code: ids.siniestroEmpresa,
    Description: 'Siniestros',
    parentCode: ids.siniestrosEmpresa,
  },
  {
    Code: ids.denunciasEmpresa,
    Description: 'Denuncias',
    parentCode: ids.siniestrosEmpresa,
  },
  {
    Code: ids.prestacionesEmpresa,
    Description: 'Prestaciones económicas',
    parentCode: ids.siniestrosEmpresa,
  },

  {
    Code: ids.movilidad,
    Description: 'Plan de Movilidad',
    parentCode: ids.miEmpresa,
  },
  {
    Code: ids.gestorMovilidad,
    Description: 'Gestor de plan de movilidad',
    parentCode: ids.movilidad,
  },
  {
    Code: ids.adminMovilidad,
    Description: 'Administrador de plan de movilidad',
    parentCode: ids.movilidad,
  },

  { Code: ids.miPerfil, Description: 'Mi Cuenta' },
  {
    Code: ids.resumenMiCuenta,
    Description: 'Resumen mi cuenta',
    parentCode: ids.miPerfil,
  },
  {
    Code: ids.usuario,
    Description: 'Usuario',
    parentCode: ids.resumenMiCuenta,
  },
  { Code: ids.misDatos, Description: 'datos', parentCode: ids.resumenMiCuenta },
  {
    Code: ids.correoPassword,
    Description: 'Correo y Contraseña',
    parentCode: ids.resumenMiCuenta,
  },
  {
    Code: ids.miCuentaSolicitudes,
    Description: 'Solicitudes',
    parentCode: ids.miPerfil,
  },
  {
    Code: ids.solicitudesPendientes,
    Description: 'Solicitudes pendientes',
    parentCode: ids.miCuentaSolicitudes,
  },
  {
    Code: ids.miCuentaNotificaciones,
    Description: 'Notificaciones',
    parentCode: ids.miPerfil,
  },
  {
    Code: ids.notificacionesT,
    Description: 'Historial de notificaciones',
    parentCode: ids.miCuentaNotificaciones,
  },
  {
    Code: ids.mantenedorNotTrabajador,
    Description: 'Configuración Notificaciones',
    parentCode: ids.miCuentaNotificaciones,
  },
  {
    Code: ids.empresasAchs,
    Description: 'Empresas ACHS',
    parentCode: ids.miPerfil,
  },
  {
    Code: ids.empresasAutoasginadas,
    Description: 'Empresas Autoasignadas',
    parentCode: ids.empresasAchs,
  },
  {
    Code: ids.contactCenter,
    Description: 'Contact Center',
    parentCode: ids.miPerfil,
  },

  { Code: ids.mantenedores, Description: 'Mantenedores' },
  {
    Code: ids.mantenedorGeneral,
    Description: 'General',
    parentCode: ids.mantenedores,
  },
  { Code: ids.roles, Description: 'Roles', parentCode: ids.mantenedorGeneral },
  {
    Code: ids.perfiles,
    Description: 'Perfiles',
    parentCode: ids.mantenedorGeneral,
  },
  {
    Code: ids.mantenedorNotificaciones,
    Description: 'Mantenedor Notificaciones',
    parentCode: ids.mantenedores,
  },
  {
    Code: ids.mantenedorNotEmpresa,
    Description: 'Notificaciones Empresa',
    parentCode: ids.mantenedorNotificaciones,
  },

  { Code: ids.portalExterno, Description: 'Portales Externos' },
  {
    Code: ids.portalEmpresa,
    Description: 'Portal Empresa',
    parentCode: ids.portalExterno,
  },
  { Code: ids.lgf, Description: 'LGF', parentCode: ids.portalExterno },
  {
    Code: ids.achsGestion,
    Description: 'ACHS Gestión',
    parentCode: ids.portalExterno,
  },

  { Code: ids.sel, Description: 'SEL' },
  { Code: ids.agendaSel, Description: 'Agenda SEL', parentCode: ids.sel },
  { Code: ids.callCenter, Description: 'Call Center', parentCode: ids.sel },
  {
    Code: ids.solicitudSel,
    Description: 'Solicitudes',
    parentCode: ids.agendaSel,
  },
  { Code: ids.crearSel, Description: 'Crear Cita', parentCode: ids.agendaSel },
  {
    Code: ids.declaracionCotizacion,
    Description: 'Confirmación',
    parentCode: ids.declaracionCotizacion,
  },
  {
    Code: ids.seleccionarEmpresaSel,
    Description: 'Seleccionar empresa SEL habilitada',
    parentCode: ids.agendaSel,
  },
  {
    Code: ids.confirmacionSolicitudSel,
    Description: 'Confirmación',
    parentCode: ids.agendaSel,
  },

  { Code: ids.movilidad, Description: 'Plan de Movilidad' },
  {
    Code: ids.gestorMovilidad,
    Description: 'Gestor de plan de movilidad',
    parentCode: ids.movilidad,
  },
  {
    Code: ids.adminMovilidad,
    Description: 'Administrador de plan de movilidad',
    parentCode: ids.movilidad,
  },
];

export default listaFuncionalidades;
